const ORDENES = [
    { group: "datos de la orden", key: "pedido", label: "Referencia"},
    { group: "datos de la orden", key: "tipo_servicio", label: "Tipo de servicio"},
    { group: "datos del app", key: "status", label: "Estado App"},
    { group: "datos personales", key: "destinatario", label: "Destinatario"},
    { group: "datos personales", key: "phone", label: "Teléfono"},
    { group: "datos personales", key: "email", label: "Email"},
    { group: "datos de ubicación", key: "direccion", label: "Dirección"},
    { group: "datos de la orden", key: "volumen", label: "Volumen"},
    { group: "datos de la orden", key: "peso", label: "Peso"},
    { group: "datos de la orden", key: "bultos", label: "Bultos"},
    { group: "datos de la orden", key: "ruta", label: "Ruta"},
    { group: "fechas", key: "compromiso", label: "Compromiso"},
    { group: "fechas", key: "fecha_compromiso_desde", label: "Fecha recogida estimada"},
    { group: "fechas", key: "fecha_compromiso_hasta", label: "Fecha entrega estimada"},
    { group: "fechas", key: "fecha_entregado", label: "Fecha entregado"},
    { group: "datos de la orden", key: "conductor", label: "Conductor"},
    { group: "datos de la orden", key: "conductor_asignado", label: "Conductor asignado"},
    { group: "datos del app", key: "visible", label: "Visible en app"},
    { group: "datos del app", key: "finalizado", label: "Finalizado"},
    { group: "datos de ubicación", key: "pais", label: "País"},
    { group: "datos de ubicación", key: "region", label: "Región"},
    { group: "datos de ubicación", key: "comuna", label: "Comuna"},
    { group: "fechas", key: "fecha", label: "Fecha creado"}
]


export const Esquema = {
    ORDENES:ORDENES
}